/* eslint-disable */
var klevu_uc = {
  loadLayout: function () {
    if (
      ((klevu_uiLabels.filter_category = 'categories'),
      'undefined' != typeof klevuLayoutVersion)
    ) {
      ;(klevu_userOptions.minimumLetters = 1),
        (klevu_userOptions.autoComplete = !0),
        'undefined' != typeof klevu_categorySearchEnabled &&
          klevu_categorySearchEnabled &&
          (klevu_userOptions.autoCompleteFilters = 'category'),
        ('undefined' != typeof klevu_cms_module_enabled &&
          klevu_cms_module_enabled &&
          klevu_cmsSearchEnabled) ||
        ('undefined' != typeof klevu_shopifyStore &&
          klevu_shopifyStore &&
          'undefined' != typeof klevu_cmsEnabled &&
          klevu_cmsEnabled) ||
        ('undefined' != typeof klevu_bigCommerceStore &&
          klevu_bigCommerceStore &&
          'undefined' != typeof klevu_cmsEnabled &&
          klevu_cmsEnabled)
          ? ((klevu_userOptions.cmsEnabled = !0),
            (klevu_cmsApiKey = klevu_apiKey),
            klevu_userOptions.autoCompleteFilters.trim().length > 0
              ? (klevu_userOptions.autoCompleteFilters += ':cms')
              : (klevu_userOptions.autoCompleteFilters = 'category:cms'))
          : (klevu_userOptions.cmsEnabled = !1),
        (klevu_userOptions.layoutVersion = '2.0'),
        (klevu_userOptions.recordsPerPage = 3),
        'undefined' != typeof klevu_productsToShowInSlimLayout &&
          (klevu_userOptions.recordsPerPage = klevu_productsToShowInSlimLayout),
        (klevu_userOptions.fetchFilters = !1),
        (klevu_userOptions.rsPsClickBehaviour = 'redirect'),
        'undefined' != typeof klevu_rsPsClickBehaviour &&
          (klevu_userOptions.rsPsClickBehaviour =
            klevu_rsPsClickBehaviour || 'redirect'),
        void 0 !== klevu_uc &&
          void 0 !== klevu_uc.showResultsData &&
          (klevu_layout.renderResults = klevu_uc.showResultsData),
        void 0 !== klevu_uc &&
          void 0 !== klevu_uc.addAutocompleteLayoutToPage &&
          (klevu_layoutSetup.addLayoutToPage =
            klevu_uc.addAutocompleteLayoutToPage),
        void 0 !== klevu_uc &&
          void 0 !== klevu_uc.showAutocompleteProducts &&
          (klevu_layout.displayProductdata = klevu_uc.showAutocompleteProducts),
        void 0 !== klevu_uc &&
          void 0 !== klevu_uc.displayNoResultData &&
          (klevu_layout.displayNoResultData = klevu_uc.displayNoResultData),
        klevu_layoutSetup.addLayoutToPage(
          document.getElementsByTagName('body')[0]
        )
      try {
        var e = document.getElementById('klevu-pt-rs-hover'),
          l = document.getElementById('klevuSearchingArea'),
          t = new MutationObserver(function (e, l) {
            var t = !0,
              s = !1,
              n = void 0
            try {
              for (
                var a, o = e[Symbol.iterator]();
                !(t = (a = o.next()).done);
                t = !0
              ) {
                var u = a.value
                u.attributeName && 'none' !== u.target.style.display
                  ? document
                      .querySelector('body')
                      .classList.add('klevu-quick-autocomplete')
                  : 'block' !== u.target.style.display &&
                    document
                      .querySelector('body')
                      .classList.remove('klevu-quick-autocomplete')
              }
            } catch (e) {
              ;(s = !0), (n = e)
            } finally {
              try {
                t || null == o.return || o.return()
              } finally {
                if (s) throw n
              }
            }
          })
        new MutationObserver(function (e, l) {
          var t = !0,
            s = !1,
            n = void 0
          try {
            for (
              var a, o = e[Symbol.iterator]();
              !(t = (a = o.next()).done);
              t = !0
            ) {
              var u = a.value
              u.attributeName && 'none' !== u.target.style.display
                ? (document
                    .querySelector('body')
                    .classList.add('klevu-quick-autocomplete'),
                  window.innerWidth < 901 && uc_helperFunctions.reorderPrElem())
                : 'block' !== u.target.style.display &&
                  document
                    .querySelector('body')
                    .classList.remove('klevu-quick-autocomplete')
            }
          } catch (e) {
            ;(s = !0), (n = e)
          } finally {
            try {
              t || null == o.return || o.return()
            } finally {
              if (s) throw n
            }
          }
        }).observe(e, {
          attributes: !0
        }),
          t.observe(l, {
            attributes: !0
          })
      } catch (e) {
        console.log('KLEVU Mutation observer error', e)
      }
    } else setTimeout(klevu_loadLayout, 200)
  },
  displayNoResultData: function (e) {
    e.msgToShow ||
      (e = klevu_commons.getNoResultsData(klevu_uiLabels.noRecords, e))
    var l,
      t = '',
      s = e.products || [],
      n = klevu_userOptions.noResultsOptions,
      a = !1,
      o = document.createElement('div')
    if (
      ((t += '<div class="klevuSearchNoResults-Inner">'),
      ((n && n.showPopularKeywords) ||
        klevu_userOptions.showPopularKeywordsForNoResult) &&
        (a = !0),
      'undefined' != typeof klevu_webstorePopularTerms &&
        klevu_webstorePopularTerms &&
        a)
    ) {
      var u = klevu_webstorePopularTerms,
        r = 1
      if (
        ((t += '<div class="klevuNoResults-pSearch">'),
        (t +=
          '<div class="klevuNoResults-message klevuNoResults-message-mobile" aria-live="assertive" role="status" tabindex="0">' +
          e.msgToShow +
          '</div>'),
        (t +=
          '<strong class="klevuNoResults-pSearchTitle">' +
          klevu_uiLabels.popularSearches +
          ' </strong>'),
        (t += '<ul class="uc__noResultsPopSearchesList">'),
        u && u.length > 0)
      )
        for (i = 0; i < u.length; i++) {
          try {
            t +=
              '<li><a href="' +
              e.landingPageUrl +
              encodeURIComponent(decodeURIComponent(u[i])) +
              '" target="_self">' +
              decodeURIComponent(u[i]) +
              '</a></li>'
          } catch (e) {
            continue
          }
          if (5 == r) break
          r++
        }
      ;(t += '</ul>'),
        (t += '</div>\x3c!-- ends klevuNoResults-popularSearch--\x3e')
    }
    if (s && s.length > 0) {
      ;(t += '<div class="klevuSearchNoResultsBlock">'),
        (t +=
          '<div class="klevuNoResults-message klevuNoResults-message-desktop" aria-live="assertive" role="status" tabindex="0">' +
          e.msgToShow +
          '</div>'),
        (t += '<div class="klevuSearchNoResults-l2">'),
        (t +=
          '<div class="klevuSearchNoResultsHeading">' +
          e.headingForNoResultProducts +
          '</div>'),
        (t += '<ul>')
      for (var i = 0; i < s.length; i++)
        (t += '<li>'),
          (t += '<a href="' + s[i].url + '" class="klevu-noResultsBox-l2"'),
          klevu_commons.isMobileDevice()
            ? (t +=
                ' onclick="return  klevu_analytics.trackClickedProduct(event, ' +
                e.trackingParams[i] +
                ');" target="_self" >')
            : (t +=
                ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' +
                e.trackingParams[i] +
                ');"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
                e.trackingParams[i] +
                ', klevu_analytics.trackClickedProduct);" ' +
                e.additionalParams +
                ' >'),
          ('undefined' == typeof klevu_truncateDescription ||
            ('undefined' != typeof klevu_truncateDescription &&
              klevu_truncateDescription)) &&
            s[i].desc.length > 33 &&
            (s[i].desc = s[i].desc.replace(/^(.{33}[^\s]*).*/, '$1') + ' ...'),
          (o.innerHTML = s[i].name),
          (l = o.textContent || o.innerText || ''),
          (t += '<div class="klevu-img-wrap-l2">'),
          (t +=
            '<img src="' +
            s[i].imageUrl +
            '" onerror="this.onerror=null;this.src=\'' +
            klevu_userOptions.noImageUrl +
            '\';" alt="' +
            klevu_commons.escapeHtml(l) +
            '" /></div>'),
          (t += '<div class="klevu-name-desc-l2">'),
          (t += '<div class="klevu-name-l2">' + s[i].name + '</div>'),
          (t += '<div class="klevu-desc-l2">' + s[i].desc + '</div>'),
          klevu_showPrices &&
            ((t += '<div class="klevu-price-l2">'),
            klevu_userOptions.showOnlyOriginalAndSalePrices
              ? (t += klevu_commons.showOriginalAndSalePrices(
                  'SLIM',
                  s[i],
                  'klevu-saleprice-l2',
                  'klevu-saleprice-l2 klevu-special-price-l2'
                ))
              : (t += klevu_commons.showProductPrices(
                  'SLIM',
                  s[i],
                  'klevu-saleprice-l2',
                  'klevu-saleprice-l2 klevu-special-price-l2'
                )),
            (t += '</div>')),
          (t += '</div>'),
          (t += '<div class="klevu-clear-left"></div>'),
          (t += '</a>'),
          (t += '</li>')
      ;(t += '</ul>'), (t += '</div>'), (t += '</div>')
    }
    return (
      e.banner &&
        e.banner.showOnQuickSearch &&
        ((trackingParams =
          "{id: '" +
          e.banner.bannerRef +
          "',name: '" +
          e.banner.bannerName +
          "',image: '" +
          escape(e.banner.bannerImageUrl) +
          "',redirectUrl: '" +
          e.banner.redirectUrl +
          "'}"),
        klevu_commons.isMobileDevice()
          ? (trackingEvent = ' onclick=')
          : (trackingEvent =
              ' onclick="klevu_analytics.stopClickDefault( event );"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' +
              trackingParams +
              ', klevu_analytics.trackClickedBannerAds);"  onmousedown='),
        (trackingEvent +=
          '"return klevu_analytics.trackClickedBannerAds(event, ' +
          trackingParams +
          ');" target="_blank">'),
        (t +=
          '<div class="kuNoResults-banner"><a href="' +
          e.banner.redirectUrl +
          '" ' +
          trackingEvent +
          '<img src="' +
          e.banner.bannerImageUrl +
          '" alt="' +
          e.banner.bannerName +
          '"/></a></div>')),
      (t += '</div>\x3c!-- ends klevuNoResults-Inner--\x3e')
    )
  }
}
